import { module } from 'modujs';
import { formDeserialize } from '../utils/html'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                clear: 'clearFilters'
            }
        }
    }

    init() {
        //custom url from html attributes
        this.urlRedirect = this.getData('url-redirect')

        this.submitBind = this.handleSubmit.bind(this)
        this.el.addEventListener('submit', this.submitBind)

        this.setFormData()
    }

    /**
     * Set form data
     * Will apply data on a form from url params
     *
     */
    setFormData() {
        const url = new URL(window.location.href)

        if(url.search) {
            formDeserialize(this.el, url.search)
        } else {
            this.el.reset()
        }
    }

    /**
     * Clear current filters
     *
     * @param
     * @return
     */
    clearFilters() {
        //Clear ghost select
        this.call('reset', null, 'SortByMirror')

        this.el.reset()
        this.el.requestSubmit()
    }

    /**
     * Update sortby select
     *
     */
    updateSortBy(value) {
        const sortByValue = value

        if(this.$('sortBy')[0] && this.$('sortBy')[0].length) {
            this.$('sortBy')[0].value = sortByValue

            this.el.requestSubmit()
        }
    }

    /**
     * Handle sumbit and query parameters
     * ⚠️ Won't work on IE11
     *
     * @param {event}
     */
    handleSubmit(event) {
        event.preventDefault();

        let url = window.location.href;

        //Retrieve FormData
        const formData = new FormData(event.target);

        //Clear empty fields from FormData
        for (const entry of Array.from(formData.entries())) {
             if(!entry[1]) {
                formData.delete(entry[0])
            }
        }

        //Create parameters string
        const parametersString = new URLSearchParams(formData).toString();

        if(this.urlRedirect) {
            url = this.urlRedirect
        }

        //Construct final URL
        const queryUrl = (parametersString.length > 0) ? `${url.split('?')[0]}?${parametersString}` : url.split('?')[0]

        // Launch transition
        this.call('goTo', { url: queryUrl, transition: 'filter' }, 'Load')
    }
}
